// @ts-nocheck
/**
 * Quote Request Modal - Simple implementation without Component inheritance
 */

function getSelectedNfc(productForm) {
  // Standalone NFC tab
  const nfcInput = productForm.querySelector('[data-nfc-input]:checked');
  if (nfcInput) {
    return nfcInput.value === 'with-nfc' ? 'With NFC' : 'Without NFC';
  }

  // Dynamic variant picker radio group labeled "NFC Chip"
  const radioGroups = productForm.querySelectorAll('.product-dynamic-variant-picker__radios');
  for (const group of radioGroups) {
    const field = group.closest('.product-dynamic-variant-picker__option');
    const label = field?.querySelector('.product-form__field-label');
    if (label && /NFC\s*Chip/i.test(label.textContent)) {
      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
    }
  }

  return '';
}

function isWithNfc(productForm) {
  // Standalone NFC tab
  const nfcInput = productForm?.querySelector('[data-nfc-input][value="with-nfc"]:checked');
  if (nfcInput) return true;

  // Dynamic variant picker radio group labeled "NFC Chip"
  const nfcOption = productForm?.querySelector('input[type="radio"][data-option-index][value*="NFC"]:checked');
  if (nfcOption) {
    const value = nfcOption.value.toLowerCase();
    if (value.includes('without')) return false;
    return /^with\b/.test(value);
  }

  return false;
}

function getSelectedSticker(productForm) {
  // Add-on select (product-addons.liquid)
  const stickerSelect = productForm.querySelector('select[data-addon-type="sticker"]');
  if (stickerSelect && stickerSelect.value) {
    const selectedOption = stickerSelect.options[stickerSelect.selectedIndex];
    return selectedOption ? selectedOption.textContent.trim() : (stickerSelect.dataset.addonTitle || 'Sticker');
  }

  // Dynamic variant picker radio group labeled "Sticker"
  const radioGroups = productForm.querySelectorAll('.product-dynamic-variant-picker__radios');
  for (const group of radioGroups) {
    const field = group.closest('.product-dynamic-variant-picker__option');
    const label = field?.querySelector('.product-form__field-label');
    if (label && /Sticker/i.test(label.textContent)) {
      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
    }
  }

  return '';
}

function getDecorationKey(rawValue, isNewProduction, pricingData) {
  if (!rawValue) return '';

  // Strip lead time text from the option value
  let key = rawValue.replace(/\s*\(.*\)\s*$/, '').trim();

  if (key === 'Embroidery') {
    key = 'Flat Embroidery';
  }

  if (!isNewProduction) {
    return key;
  }

  const addOnKey = `${key} (Add-on)`;
  if (pricingData && pricingData[addOnKey]) return addOnKey;
  return pricingData && pricingData[key] ? key : addOnKey;
}

function getSelectedAddonDecorations(productForm) {
  const selects = productForm.querySelectorAll('select[data-addon-type="decoration"]');
  const selected = [];
  for (const select of selects) {
    if (!select.value) continue;
    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) continue;
    const price = Number(selectedOption.dataset.addonPrice || 0) / 100;
    selected.push({
      title: select.dataset.addonTitle || '',
      variantId: select.value,
      variantTitle: selectedOption.textContent.trim(),
      price,
    });
  }
  return selected;
}

(function() {
  let currentStep = 1;
  let productData = null;
  const totalSteps = 3;
  const HUBSPOT_SUBMIT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit/50628284/74528f2d-9eec-4750-849d-92f560e68dc8';

  // Initialize when DOM is ready
  function init() {
    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) {
      return;
    }

    const dialog = modal.querySelector('dialog');
    const closeButton = modal.querySelector('[ref="closeButton"]');
    const submitButton = modal.querySelector('[data-submit-button]');
    const closeSuccessButton = modal.querySelector('[data-close-success-button]');

    // Set up event listeners
    closeButton?.addEventListener('click', closeModal);
    submitButton?.addEventListener('click', handleSubmit);
    closeSuccessButton?.addEventListener('click', closeModal);
    initQuoteQuantityControl(modal);

    // Use event delegation for continue and back buttons (multiple steps have these buttons)
    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-continue-button]')) {
        handleContinue();
      }
      if (e.target.closest('[data-previous-button]')) {
        handlePrevious();
      }
    });

    // Listen for open requests
    document.addEventListener('quote-request:open', handleOpenRequest);

    // Re-calculate cost summary if the active form's NFC option changes while the modal is open.
    document.addEventListener('change', (event) => {
      if (!productData?.productHandle) return;
      const activeForm = document.querySelector(`product-form-component[data-product-handle="${productData.productHandle}"]`);
      if (!activeForm || !activeForm.contains(event.target)) return;
      if (
        event.target.matches('[data-nfc-input]') ||
        (event.target.matches('input[type="radio"][data-option-index]') && (event.target.value || '').toLowerCase().includes('nfc'))
      ) {
        populateCostSummary();
      }
    });
  }

  function handleOpenRequest(event) {
    productData = event.detail?.productData || {};
    populateProductData();
    resetForm();
    showStep(1);
    openModal();
  }

  function populateProductData() {
    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) return;

    if (!productData) return;

    const { title, variant, quantity, color, decoration, addonDecorations, delivery, sticker, nfc, productType } = productData;

    let detailsHtml = '';
    if (title) detailsHtml += `<p><strong>Product:</strong> ${title}</p>`;
    if (productType) detailsHtml += `<p><strong>Product Type:</strong> ${productType}</p>`;
    if (variant) detailsHtml += `<p><strong>Variant:</strong> ${variant}</p>`;
    if (quantity) detailsHtml += `<p><strong>Quantity:</strong> ${quantity}</p>`;
    if (color) detailsHtml += `<p><strong>Color:</strong> ${color}</p>`;
    if (decoration) {
      const isIncludedFlatEmbroidery = productData?.productHandle?.includes('-new-production') && decoration.replace(/\s*\(.*\)\s*$/, '').trim() === 'Flat Embroidery';
      detailsHtml += `<p><strong>Decoration:</strong> ${decoration}${isIncludedFlatEmbroidery ? ' (included)' : ''}</p>`;
    }
    if (addonDecorations && addonDecorations.length) {
      detailsHtml += `<p><strong>Additional Decoration:</strong> ${addonDecorations.map(a => a.title || a.variantTitle).join(', ')}</p>`;
    }
    if (sticker) detailsHtml += `<p><strong>Custom Sticker:</strong> ${sticker}</p>`;
    if (nfc) detailsHtml += `<p><strong>NFC:</strong> ${nfc}</p>`;
    if (delivery) detailsHtml += `<p><strong>Delivery:</strong> ${delivery}</p>`;

    modal.querySelectorAll('[data-product-display], [data-review-product]').forEach((el) => {
      el.innerHTML = detailsHtml || '<p>No product details available</p>';
    });

    // Populate cost summary from product-delivery__summary
    populateCostSummary();
  }

  function populateCostSummary() {
    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) return;

    // Scope to the active product form so a related product or quick view doesn't steal the price.
    const productForm = document.querySelector(`product-form-component[data-product-handle="${productData?.productHandle || ''}"]`)
      || document.querySelector('product-form-component');
    const productDelivery = productForm?.querySelector('[data-product-delivery]') || document.querySelector('[data-product-delivery]');
    if (!productDelivery || !productForm) return;

    const quantityInput = modal.querySelector('[data-quote-quantity]');
    const capUnitPriceEl = modal.querySelector('[data-cost-cap-unit-price]');
    const capSubtotalEl = modal.querySelector('[data-cost-cap-subtotal]');
    const decorationUnitPriceEl = modal.querySelector('[data-cost-decoration-unit-price]');
    const decorationSubtotalEl = modal.querySelector('[data-cost-decoration-subtotal]');
    const nfcCostEl = modal.querySelector('[data-cost-nfc]');
    const stickerCostEl = modal.querySelector('[data-cost-sticker]');
    const deliveryCostEl = modal.querySelector('[data-cost-delivery]');
    const totalCostEl = modal.querySelector('[data-cost-total]');
    const pageQuantityInput = productForm?.querySelector('input[name="quantity"]');

    if (!quantityInput) return;

    quantityInput.min = pageQuantityInput?.min || '1';
    quantityInput.max = pageQuantityInput?.max || '';
    quantityInput.step = pageQuantityInput?.step || '1';
    quantityInput.value = normalizeQuantity(quantityInput, productData?.quantity || pageQuantityInput?.value);

    const quantity = Number(quantityInput.value);
    const rawCapPrice = Number(productDelivery.getAttribute('data-cap-price') || 0) / 100;

    // Determine the selected decoration type first so we can strip its base price from the cap price.
    const decorationPricingData = modal.querySelector('[data-decoration-pricing]');
    let decorationPricing = {};
    try {
      decorationPricing = JSON.parse(decorationPricingData?.textContent || '{}');
    } catch (error) {
      console.error('Quote decoration pricing data could not be parsed:', error);
    }

    const isNewProduction = productData?.productHandle?.includes('-new-production') || false;

    let decorationType = productData?.decoration || '';

    // Strip lead time text from decoration type (e.g., "Flat Embroidery (3-7 working days)" -> "Flat Embroidery")
    if (decorationType) {
      decorationType = decorationType.replace(/\s*\(.*\)\s*$/, '');
    }
    const isBlankCap = !decorationType || decorationType.trim().toLowerCase() === 'blank cap';

    // Map "Embroidery" to "Flat Embroidery" for pricing lookup
    if (decorationType === 'Embroidery') {
      decorationType = 'Flat Embroidery';
    }

    // Calculate decoration prices.
    // Stock products: the selected decoration is the full decoration cost.
    // New production: Flat Embroidery is always included in the cap price. The selected main
    // decoration and any dropdown add-ons are layered on top, each with its own quantity breaks.
    const flatKey = getDecorationKey('Flat Embroidery', true, decorationPricing);
    const flatBase = getBaseDecorationPrice(flatKey, decorationPricing);

    const withNfc = isWithNfc(productForm);

    // data-cap-price is already the selected variant price (cap + flat + optional NFC)
    const capUnitPrice = rawCapPrice;

    let selectedDecorationUnitPrice = 0;
    let additionalDecorationUnitPrice = 0;
    let decorationUnitPrice = 0;
    let baseDecorationPrice = 0;

    if (isNewProduction && !isBlankCap) {
      const selectedDecorationKey = getDecorationKey(decorationType, true, decorationPricing);
      const flatUnitPrice = getDecorationPrice(flatKey, quantity, decorationPricing);
      const mainAddOnUnitPrice = selectedDecorationKey && selectedDecorationKey !== flatKey
        ? getDecorationPrice(selectedDecorationKey, quantity, decorationPricing)
        : 0;
      selectedDecorationUnitPrice = flatUnitPrice + mainAddOnUnitPrice;
      additionalDecorationUnitPrice = (productData?.addonDecorations || []).reduce((sum, addon) => sum + (addon.price || 0), 0);
      decorationUnitPrice = selectedDecorationUnitPrice + additionalDecorationUnitPrice;
      // Only Flat Embroidery is embedded in the cap variant price; add-ons are priced separately.
      baseDecorationPrice = flatBase;
    } else if (!isBlankCap) {
      decorationUnitPrice = getDecorationPrice(decorationType, quantity, decorationPricing);
      baseDecorationPrice = getBaseDecorationPrice(decorationType, decorationPricing);
    }

    // The variant price already includes the base decoration price; derive cap-only price.
    const capOnlyUnitPrice = capUnitPrice - baseDecorationPrice;

    const deliveryData = productDelivery.querySelector('[data-delivery-data]');
    let deliveryVariants = [];
    try {
      deliveryVariants = JSON.parse(deliveryData?.textContent || '[]').filter((variant) => variant?.available !== false);
    } catch (error) {
      console.error('Quote delivery data could not be parsed:', error);
    }

    const deliveryMethod = productDelivery.querySelector('[data-delivery-methods]')?.value;
    const tiers = [...new Set(deliveryVariants.map((variant) => Number.parseInt(variant.tier, 10)).filter(Number.isFinite))].sort((a, b) => a - b);
    const tier = tiers.find((value) => quantity <= value) || tiers[tiers.length - 1];
    const deliveryVariant = deliveryVariants.find((variant) => variant.method === deliveryMethod && Number.parseInt(variant.tier, 10) === tier);
    const deliveryCost = deliveryVariant ? deliveryVariant.price / 100 : 0;

    // Unit price shown to the customer is the combined cap + decoration per-unit price.
    // It is the only per-unit line that changes with quantity breaks.
    const setupPricePerUnit = isBlankCap ? 0 : 125 / quantity;
    const decorationTotalUnitPrice = isBlankCap ? 0 : decorationUnitPrice + setupPricePerUnit;
    const shippingPricePerUnit = deliveryCost / quantity;
    const unitPrice = capOnlyUnitPrice + decorationTotalUnitPrice + shippingPricePerUnit;
    const subtotal = unitPrice * quantity;
    const decorationSubtotal = decorationTotalUnitPrice * quantity;

    if (capUnitPriceEl) capUnitPriceEl.textContent = formatCurrency(unitPrice);
    if (capSubtotalEl) capSubtotalEl.textContent = formatCurrency(subtotal);

    if (isNewProduction && additionalDecorationUnitPrice > 0) {
      if (decorationUnitPriceEl) {
        decorationUnitPriceEl.textContent = `${formatCurrency(selectedDecorationUnitPrice + setupPricePerUnit)} + ${formatCurrency(additionalDecorationUnitPrice)}`;
      }
    } else {
      if (decorationUnitPriceEl) decorationUnitPriceEl.textContent = formatCurrency(decorationTotalUnitPrice);
    }

    if (decorationSubtotalEl) decorationSubtotalEl.textContent = formatCurrency(decorationSubtotal);

    const decorationUnitPriceRow = decorationUnitPriceEl?.closest('.msf-cost-row');
    const decorationSubtotalRow = decorationSubtotalEl?.closest('.msf-cost-row');
    if (decorationTotalUnitPrice === 0 && decorationSubtotal === 0) {
      if (decorationUnitPriceRow) decorationUnitPriceRow.classList.add('hidden');
      if (decorationSubtotalRow) decorationSubtotalRow.classList.add('hidden');
    } else {
      if (decorationUnitPriceRow) decorationUnitPriceRow.classList.remove('hidden');
      if (decorationSubtotalRow) decorationSubtotalRow.classList.remove('hidden');
    }

    if (nfcCostEl) nfcCostEl.textContent = productData?.nfc || '-';
    if (stickerCostEl) stickerCostEl.textContent = productData?.sticker || '-';
    if (deliveryCostEl) deliveryCostEl.textContent = deliveryVariant?.priceFormatted || formatCurrency(deliveryCost);
    if (totalCostEl) totalCostEl.textContent = formatCurrency(subtotal);
  }

  function getDecorationPrice(decorationType, quantity, pricingData) {
    if (!decorationType || !pricingData[decorationType]) {
      return 0;
    }

    const tiers = pricingData[decorationType];
    const tier = tiers.find(t => quantity >= t.min_qty && (t.max_qty == null || quantity <= t.max_qty));
    
    if (!tier) {
      return 0;
    }

    return tier.unit_price;
  }

  function getBaseDecorationPrice(decorationType, pricingData) {
    if (!decorationType || !pricingData[decorationType]) {
      return 0;
    }

    const tiers = pricingData[decorationType];
    if (!tiers || !tiers.length) return 0;

    const baseTier = tiers.reduce((min, t) => (t.min_qty < min.min_qty ? t : min), tiers[0]);
    return baseTier.unit_price;
  }

  function initQuoteQuantityControl(modal) {
    const quantityInput = modal.querySelector('[data-quote-quantity]');
    const decreaseButton = modal.querySelector('[data-quote-quantity-decrease]');
    const increaseButton = modal.querySelector('[data-quote-quantity-increase]');
    if (!quantityInput) return;

    const updateQuantity = (value) => {
      quantityInput.value = normalizeQuantity(quantityInput, value);
      if (productData) productData.quantity = quantityInput.value;
      populateProductData();
    };

    decreaseButton?.addEventListener('click', () => updateQuantity(Number(quantityInput.value) - Number(quantityInput.step || 1)));
    increaseButton?.addEventListener('click', () => updateQuantity(Number(quantityInput.value) + Number(quantityInput.step || 1)));
    quantityInput.addEventListener('change', () => updateQuantity(quantityInput.value));
    quantityInput.addEventListener('input', () => updateQuantity(quantityInput.value));
  }

  function normalizeQuantity(input, value) {
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    const step = Number(input.step) || 1;
    const parsedValue = Number.parseInt(value, 10);
    const quantity = Number.isFinite(parsedValue) ? parsedValue : min;
    const alignedQuantity = min + Math.round((quantity - min) / step) * step;
    return String(Math.max(min, Math.min(max, alignedQuantity)));
  }

  function formatCurrency(value) {
    return '$' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function resetForm() {
    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) return;

    const form = modal.querySelector('[data-quote-form]');
    if (form && form.reset) {
      form.reset();
    }

    // Clear review data
    const reviewName = modal.querySelector('[data-review-name]');
    const reviewEmail = modal.querySelector('[data-review-email]');
    const reviewPhone = modal.querySelector('[data-review-phone]');
    const reviewMessage = modal.querySelector('[data-review-message]');

    if (reviewName) reviewName.textContent = '';
    if (reviewEmail) reviewEmail.textContent = '';
    if (reviewPhone) reviewPhone.textContent = '';
    if (reviewMessage) reviewMessage.textContent = '';
  }

  function handleContinue() {
    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) return;

    // If on step 1, move to step 2 (form)
    if (currentStep === 1) {
      showStep(2);
      return;
    }

    // If on step 2, validate form and move to step 3 (review)
    if (currentStep === 2) {
      const form = modal.querySelector('[data-quote-form]');
      if (!form) return;

      // Validate form
      if (form.checkValidity && !form.checkValidity()) {
        if (form.reportValidity) form.reportValidity();
        return;
      }

      // Populate review data
      populateReviewData();

      // Show step 3
      showStep(3);
    }
  }

  function populateReviewData() {
    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) return;

    const form = modal.querySelector('[data-quote-form]');
    if (!form) return;
    
    const formData = new FormData(form);

    const reviewName = modal.querySelector('[data-review-name]');
    const reviewCompany = modal.querySelector('[data-review-company]');
    const reviewEmail = modal.querySelector('[data-review-email]');
    const reviewPhone = modal.querySelector('[data-review-phone]');
    const reviewMessage = modal.querySelector('[data-review-message]');

    if (reviewName) reviewName.textContent = formData.get('contact[name]') || '';
    if (reviewCompany) reviewCompany.textContent = formData.get('contact[company]') || '';
    if (reviewEmail) reviewEmail.textContent = formData.get('contact[email]') || '';
    if (reviewPhone) reviewPhone.textContent = formData.get('contact[phone]') || '';
    if (reviewMessage) reviewMessage.textContent = formData.get('contact[body]') || '';
  }

  function handlePrevious() {
    if (currentStep > 1) {
      showStep(currentStep - 1);
    }
  }

  async function handleSubmit() {
    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) return;

    const form = modal.querySelector('[data-quote-form]');
    if (!form) return;

    const submitButton = modal.querySelector('[data-submit-button]');
    const submitButtonHtml = submitButton ? submitButton.innerHTML : '';

    // Disable button during submission
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Submitting...';
    }

    try {
      const formData = new FormData(form);

      const response = await fetch(HUBSPOT_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildHubSpotPayload(formData)),
      });

      if (response.ok) {
        // Show success step
        showStep('success');
      } else {
        const errorText = await response.text().catch(() => '');
        console.error('HubSpot submission failed:', response.status, errorText);
        throw new Error('Submission failed');
      }
    } catch (error) {
      console.error('Quote request submission error:', error);
      alert('There was an error submitting your request. Please try again.');
    } finally {
      // Re-enable button
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerHTML = submitButtonHtml || 'Submit';
      }
    }
  }

  function buildHubSpotPayload(formData) {
    const data = productData || {};
    const nameParts = String(formData.get('contact[name]') || '').trim().split(/\s+/);

    // Merge main decoration with any add-on decorations (no dedicated HubSpot field)
    let decoration = data.decoration || '';
    const addonNames = (data.addonDecorations || []).map((a) => a.title || a.variantTitle).filter(Boolean);
    if (addonNames.length) {
      decoration = decoration ? `${decoration}, ${addonNames.join(', ')}` : addonNames.join(', ');
    }

    // Message plus details that have no dedicated HubSpot field
    let notes = String(formData.get('contact[body]') || '').trim();
    if (data.variant) {
      notes += `${notes ? '\n\n' : ''}Variant: ${data.variant}`;
    }

    const quantityInput = document.querySelector('[data-quote-request-modal] [data-quote-quantity]');

    return {
      submittedAt: Date.now(),
      fields: [
        { name: '0-1/firstname', value: nameParts[0] || '' },
        { name: '0-1/lastname', value: nameParts.slice(1).join(' ') },
        { name: '0-1/email', value: String(formData.get('contact[email]') || '').trim() },
        { name: '0-2/phone', value: String(formData.get('contact[phone]') || '').trim() },
        { name: '0-1/company', value: String(formData.get('contact[company]') || '').trim() },
        { name: '0-1/quantity', value: String(quantityInput?.value || data.quantity || '') },
        { name: '0-1/product_name', value: data.title || '' },
        { name: '0-1/product_sku', value: data.sku || '' },
        { name: '0-1/product_type', value: data.productType || '' },
        { name: '0-1/cap_color', value: data.color || '' },
        { name: '0-1/cap_decoration', value: decoration },
        { name: '0-1/custom_sticker', value: data.sticker || '' },
        { name: '0-1/cap_nfc', value: data.nfc || '' },
        { name: '0-1/delivery', value: data.delivery || '' },
        { name: '0-1/additional_notes', value: notes },
      ],
      context: {
        pageUri: window.location.href,
        pageName: document.title,
      },
    };
  }

  function showStep(step) {
    currentStep = step;

    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) return;

    // Update progress bar
    const progressBar = modal.querySelector('.msf-progress-bar');
    if (progressBar) {
      if (step === 'success') {
        progressBar.style.width = '100%';
      } else {
        const progress = (step / totalSteps) * 100;
        progressBar.style.width = progress + '%';
      }
    }

    // Hide all steps
    modal.querySelectorAll('[data-step]').forEach((stepEl) => {
      stepEl.classList.remove('msf-step--active');
    });

    // Show current step
    const currentStepEl = modal.querySelector(`[data-step="${step}"]`);
    if (currentStepEl) {
      currentStepEl.classList.add('msf-step--active');
    }
  }

  function closeModal() {
    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) return;

    const dialog = modal.querySelector('dialog');
    if (dialog && dialog.close) {
      // Add closing animation class
      dialog.classList.add('dialog-closing');

      // Wait for animation to complete before closing (matches --animation-speed: 0.125s)
      setTimeout(() => {
        dialog.close();
        document.body.style.overflow = '';
        dialog.classList.remove('dialog-closing');
      }, 125);
    }

    resetForm();
    showStep(1);
  }

  function openModal() {
    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) return;

    const dialog = modal.querySelector('dialog');
    if (dialog && dialog.showModal) {
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }
  }

  // Phone number formatting
  function initPhoneFormatting() {
    const modal = document.querySelector('[data-quote-request-modal]');
    if (!modal) return;

    const phoneInput = modal.querySelector('#quote-phone');
    if (phoneInput) {
      phoneInput.addEventListener('input', function (e) {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
        let formatted = '';
        if (digits.length > 6) {
          formatted = '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
        } else if (digits.length > 3) {
          formatted = '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
        } else if (digits.length > 0) {
          formatted = '(' + digits;
        }
        e.target.value = formatted;
      });
    }
  }

  // Initialize on DOM content loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Initialize phone formatting
  initPhoneFormatting();
})();

/**
 * Trigger quote request modal from product form
 */
document.addEventListener('click', (event) => {
  if (!event.target) return;
  const quoteButton = event.target.closest('.product-quote-button');
  if (quoteButton) {
    event.preventDefault();

    // Get product form data
    const productForm = quoteButton.closest('product-form-component');
    if (!productForm) {
      return;
    }

    const productData = {
      title: productForm.dataset.productHandle || '',
      productHandle: productForm.dataset.productHandle || '',
      variant: '',
      sku: '',
      quantity: '',
      color: '',
      decoration: '',
      addonDecorations: [],
      delivery: '',
      sticker: '',
      nfc: '',
      productType: '',
    };

    // Get quantity
    const quantityInput = productForm.querySelector('input[name="quantity"]');
    if (quantityInput && quantityInput.value) {
      productData.quantity = quantityInput.value;
    }

    // Get selected color
    const colorValue = productForm.querySelector('[data-color-value]');
    if (colorValue && colorValue.textContent) {
      productData.color = colorValue.textContent.trim();
    }

    // Get selected decoration — find the select whose options match decoration pricing keys
    const decorationPricingDataEl = document.querySelector('[data-quote-request-modal] [data-decoration-pricing]') || document.querySelector('[data-decoration-pricing]');
    let decorationPricingForSelect = {};
    try {
      decorationPricingForSelect = JSON.parse(decorationPricingDataEl?.textContent || '{}');
    } catch (error) {
      decorationPricingForSelect = {};
    }

    function optionMatchesDecorationPricing(value) {
      const key = value.replace(/\s*\(.*\)\s*$/, '').trim();
      return decorationPricingForSelect[key] || decorationPricingForSelect[`${key} (Add-on)`];
    }

    const selects = Array.from(productForm.querySelectorAll('select[data-option-index]'));
    const decorationSelect = selects.find(select =>
      Array.from(select.options).some(option => optionMatchesDecorationPricing(option.value))
    );
    if (decorationSelect && decorationSelect.value) {
      productData.decoration = decorationSelect.value;
    } else {
      // Decoration rendered as radios inside a dropdown — read the checked radio
      // directly so aliased/blank values don't need pricing-key matching.
      const checkedRadio = productForm.querySelector('.decoration-dropdown__radios input[type="radio"]:checked')
        || Array.from(productForm.querySelectorAll('input[type="radio"][data-option-index]:checked'))
          .find(input => optionMatchesDecorationPricing(input.value)
            || input.value.replace(/\s*\([^)]*\)\s*$/, '').trim().toLowerCase() === 'blank cap');
      if (checkedRadio) {
        productData.decoration = checkedRadio.value;
      }
    }

    // Get delivery method (rendered as a select by product-delivery.liquid)
    const deliveryField = productForm.querySelector('select[name="delivery-method"], input[name="delivery-method"]:checked');
    if (deliveryField && deliveryField.value) {
      productData.delivery = deliveryField.value;
    }

    // Get sticker selection
    productData.sticker = getSelectedSticker(productForm);

    // Get NFC selection
    productData.nfc = getSelectedNfc(productForm);

    // Get additional decoration addon(s) (new-production individual caps)
    productData.addonDecorations = getSelectedAddonDecorations(productForm);

    // Get product type metafield
    if (productForm.dataset.productType) {
      productData.productType = productForm.dataset.productType;
    }

    // Get variant info
    const variantIdInput = productForm.querySelector('input[name="id"]');
    if (variantIdInput) {
      const variantSelect = productForm.querySelector('select[name="id"]');
      if (variantSelect) {
        const selectedOption = variantSelect.querySelector(`option[value="${variantIdInput.value}"]`);
        if (selectedOption && selectedOption.textContent) {
          productData.variant = selectedOption.textContent;
        }
      }
    }

    // Get SKU (hidden input kept in sync on variant change)
    const skuInput = productForm.querySelector('input[name="sku"]');
    if (skuInput && skuInput.value) {
      productData.sku = skuInput.value;
    }

    // Get product title from page
    const productTitle = document.querySelector('h1');
    if (productTitle && productTitle.textContent) {
      productData.title = productTitle.textContent;
    }

    // Dispatch event to open modal
    document.dispatchEvent(new CustomEvent('quote-request:open', {
      detail: { productData }
    }));
  }
});
